import { Button, ButtonGroup, Stack } from '@chakra-ui/react';
import { LuLayout } from 'react-icons/lu';
import { NestedHome } from '@habity/types';
import { ProfileModalType } from '@habity/types/modals';
import { Gi3DStairs } from 'react-icons/gi';
import { useTranslations } from 'next-intl';
import { hasVirtualTour } from '~/lib/homes/profile/virtualTour';

export const ProfileButtons = ({
  home,
  handleOpen,
}: {
  home: NestedHome;
  handleOpen: (params: ProfileModalType) => void;
}) => {
  const { provider_data } = home || {};
  const { images } = provider_data || {};
  const floorPlans = images?.filter(
    (image) => image.category === 'Planritningar' && image.showImageOnInternet
  );
  const t = useTranslations('HomeProfile.Accordions');
  return (
    <Stack position="absolute" zIndex="1" bottom="4" right="4">
      <ButtonGroup>
        {floorPlans && floorPlans.length > 0 && (
          <Button
            bg="white"
            color="gray.800"
            as="a"
            href="#"
            size="sm"
            leftIcon={<LuLayout />}
            onClick={() => handleOpen({ modalType: 'floorPlan', open: true })}
          >
            {t('FloorPlan.title')}
          </Button>
        )}

        {hasVirtualTour(home) && (
          <Button
            bg="white"
            color="gray.800"
            as="a"
            href="#"
            size="sm"
            leftIcon={<Gi3DStairs />}
            onClick={() => handleOpen({ modalType: 'virtualTour', open: true })}
          >
            {t('VirtualTour.title')}
          </Button>
        )}
      </ButtonGroup>
    </Stack>
  );
};
